import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Products from './components/Products';
import Services from './components/Services';
import Reservation from './components/Reservation';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminReservations from './components/AdminReservations';
import KitConfigurator from './components/KitConfigurator';
import WhatsAppButton from './components/WhatsAppButton';
import { Toaster } from './components/ui/sonner';
import './App.css';

function HomePage() {
  return (
    <>
      <Header />
      <Hero />
      <Products />
      <Services />
      <Reservation />
      <Contact />
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/configurator" element={<KitConfigurator />} />
            <Route path="/admin-reservations" element={<AdminReservations />} />
          </Routes>
          <Toaster position="top-right" />
          <WhatsAppButton />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
